(() => {
  const INPUT_SELECTOR = 'input.custom-tag-facet__checkbox[data-custom-tag-url]';
  const LINK_SELECTOR = 'a.custom-tag-facet__pill[data-custom-tag-url]';
  let inFlight = false;

  const setLoadingState = (isLoading) => {
    document.querySelectorAll('#ProductGridContainer, #main-collection-filters').forEach((el) => {
      if (!el) return;
      if (isLoading) {
        el.setAttribute('aria-busy', 'true');
      } else {
        el.removeAttribute('aria-busy');
      }
    });
  };

  const swapFromDocument = (sourceDoc) => {
    const targetPairs = [
      ['#ProductGridContainer', '#ProductGridContainer'],
      ['#main-collection-filters', '#main-collection-filters'],
    ];

    targetPairs.forEach(([fromSelector, toSelector]) => {
      const incoming = sourceDoc.querySelector(fromSelector);
      const current = document.querySelector(toSelector);
      if (incoming && current) {
        current.replaceWith(incoming);
      }
    });
  };

  const loadFacetsUrl = async (url, pushState = true) => {
    if (!url || inFlight) return;
    inFlight = true;
    setLoadingState(true);

    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      const html = await response.text();
      const sourceDoc = new DOMParser().parseFromString(html, 'text/html');
      swapFromDocument(sourceDoc);
      if (pushState) {
        window.history.pushState({ customTagFacets: true }, '', url);
      }
    } catch (_error) {
      window.location.assign(url);
    } finally {
      setLoadingState(false);
      inFlight = false;
    }
  };

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target.closest(INPUT_SELECTOR);
      if (!input) return;
      const url = input.dataset.customTagUrl;
      if (!url) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      loadFacetsUrl(url, true);
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest(LINK_SELECTOR);
      if (!link) return;
      const url = link.dataset.customTagUrl || link.getAttribute('href');
      if (!url) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      loadFacetsUrl(url, true);
    },
    true
  );

  window.addEventListener('popstate', () => {
    loadFacetsUrl(window.location.href, false);
  });
})();
